<template>
  <div class="page-content">
    <h1 class="page-title">{{ $locale("sideMenu.film.classification") }}</h1>
    <List
      :tableHeaderData="tableHeaderData"
      :tableData="versionList"
      style="margin-top: 25px"
      :noDelete="true"
      name="restrict"
    />

    <Dialog
      :closeAction="closeDialog"
      :visible="dialogVisible"
      :confirmAction="submitVersonForm"
      :titleText="$locale('restrict.verMasterCreateEdit')"
      width="660px"
    >
      <el-form ref="editForm" :model="versionDetailData" :rules="formRules">
        <el-form-item :label="$locale('global.name')" prop="name">
          <el-input
            :placeholder="$locale('form.plsEnterYourName')"
            v-model="versionDetailData.name"
						disabled
          ></el-input>
        </el-form-item>
				<el-form-item :label="$locale('restrict.titleDisplay')" prop="display">
					<el-select
						v-model="versionDetailData.display"
					>
						<el-option
							:label="$locale('global.no')"
							:value="false"
							:key="false"
						></el-option>
						<el-option
							:label="$locale('global.yes')"
							:value="true"
							:key="true"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$locale('version.screen.header.pos')" prop="displayPosMsg">
          <el-input v-model="versionDetailData.displayPosMsg"></el-input>
        </el-form-item>
        <el-form-item :label="$locale('version.screen.header.net')" prop="displayOnlineMsg">
          <el-input v-model="versionDetailData.displayOnlineMsg"></el-input>
        </el-form-item>
        <el-form-item :label="$locale('version.screen.header.cc')" prop="displaySelfCashierMsg">
          <el-input
            v-model="versionDetailData.displaySelfCashierMsg"
          ></el-input>
        </el-form-item>
      </el-form>
    </Dialog>
  </div>
</template>

<script>
import "@/assets/style/versionManagement.less";
import List from "@/components/Version/list.vue";
import Dialog from "@/components/Version/dialog.vue";
import {
  getEthicalService,
  updateEthicalService,
} from "@/helpers/service/api/restrict";
import countDownAlert from "@/utils/countDownAlert";


export default {
  components: {
    Dialog,
    List
  },
  data() {
    return {
      cinemaId: window.localStorage.getItem("cinemaId"),
      dialogVisible: false,
      versionDetailData: {
        displayOnlineMsg: "",
        displayPosMsg: "",
        displaySelfCashierMsg: "",
        id: "",
        name: "",
        display: "",
        displayTitle: "",
      },
      versionList: [],
      tableHeaderData: [
        {
          prop: "name",
          label: this.$locale("global.name"),
          width: 100,
        },
        {
          prop: "displayTitle",
          label: this.$locale("restrict.titleDisplay"),
          width: 60,
        },
        {
          label: this.$locale("version.screen.header.pos"),
          prop: "displayPosMsg",
          width: 120,
        },
        {
          label: this.$locale("version.screen.header.net"),
          prop: "displayOnlineMsg",
          width: 120,
        },
        {
          label: this.$locale("version.screen.header.cc"),
          prop: "displaySelfCashierMsg",
          width: 120,
        },
      ],
      isUpdate: false,
      formRules: {
        name: [
          {
            required: true,
            message: this.$locale("form.plsEnterYourName")
          }
        ],
      }
    };
  },
  created() {
    if (!this.cinemaId) {
      this.$emit("callCinema", "getVersionList");
      return;
    }
    this.getVersionList();
  },
  methods: {
    getVersionList() {
      // getVersionService({
      //   cinemaId: this.cinemaId,
      //   page: this.currentPage,
      //   ...this.searchFilter,
      // }).then(res => {
      //   this.versionList = res.data.data;
      //   this.count = res.data.count;
      // });
      getEthicalService({
        cinemaId: this.cinemaId,
      }).then(res => {
        let { data } = res.data;
        data.forEach(item => {
          if (!item.display) {
            item.displayTitle = "いいえ";
          } else {
            item.displayTitle = "はい";
          }
        });
        this.versionList = data;
      });
    },
    createAction() {
      this.isUpdate = false;
      this.openDialog();
    },
    editAction(context) {
      this.isUpdate = true;
      this.versionDetailData = { ...context };
      this.openDialog();
    },
    submitVersonForm() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          const requestParam = {
            ...this.versionDetailData,
            cinemaId: this.cinemaId,
          };
          const requestScuessFn = (res, content) => {
            if (!res.success) {
              return;
            }

            countDownAlert({ content });
            this.closeDialog();
            this.getVersionList();
          };

          updateEthicalService(requestParam).then(res => {
            requestScuessFn(res, this.$locale("global.updateSuccessfully"));
          });
        }
      });
    },
    openDialog() {
      this.dialogVisible = true;
    },
    closeDialog() {
      this.versionDetailData = {
        cinemaId: this.cinemaId,
        description: "",
        displayOnlineMsg: "",
        displayPosMsg: "",
        displaySelfCashierMsg: "",
        id: "",
        name: "",
      };
      this.dialogVisible = false;
    },
  },
};
</script>
